export const POINT_CLICK_THRESHOLD = 0.001
export const HIGH_PRECISION_ZOOM_RANGE = [2, 5] // 200% -> 1000%
export const SIMPLIFICATION_EPSILON_RANGE = [0.1, 0.5]

/**
 * Maximum number of annotations that can be selected at once.
 *
 * This limit exists to:
 * - Avoid performance issues with large selections
 * - Limit parallel requests sent to the backend
 * - Maintain responsive UI during multi-annotation operations
 */
export const MAX_SELECTED_ANNOTATIONS = 50
